const spinner = `<svg class="loading-spinner" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
<style>
    @keyframes yellow-circle {
        0% {
            stroke-dashoffset: 141.3;
            transform: rotateZ(-108deg);
        }

        50% {
            stroke-dashoffset: 113.04;
            transform: rotateZ(39.6deg);
        }

        100% {
            stroke-dashoffset: 141.3;
            transform: rotateZ(252deg);
        }
    }

    @keyframes light-green-circle {
        0% {
            stroke-dashoffset: 113.04;
            transform: rotateZ(-140.4deg);
        }

        50% {
            stroke-dashoffset: 51.81;
            transform: rotateZ(1.8deg);
        }

        100% {
            stroke-dashoffset: 113.04;
            transform: rotateZ(219.6deg);
        }
    }

    .loading-spinner {
        width: 100%;
        height: 100%;
        stroke-linecap: round;
        stroke-width: 6;
        fill: none;
    }

    .loader-circle {
        stroke-dasharray: 157;
        transform-origin: center;
    }

    .loader-circle-yellow {
        stroke: #ffd200;
        stroke-dashoffset: 141.3;
        transform: rotateZ(-108deg);
        animation: yellow-circle 1s linear infinite;
    }

    .loader-circle-light-green {
        stroke-dashoffset: 113.04;
        stroke: #86d1cd;
        transform: rotateZ(-140.4deg);
        animation: light-green-circle 1s linear infinite;
    }

    .loader-circle-dark-green {
        stroke: #37aba1;
    }
</style>
    <circle class="loader-circle loader-circle-dark-green" cx="28" cy="28" r="25"></circle>
    <!-- transform is ie11 fallback -->
    <circle class="loader-circle loader-circle-light-green" cx="28" cy="28" r="25" transform='rotate(-140.4 28 28)'></circle>
    <circle class="loader-circle loader-circle-yellow" cx="28" cy="28" r="25" transform='rotate(-108 28 28)'></circle>
</svg>`;
export default spinner;
